import getColor from "@insite/mobius/utilities/getColor";
import { purchasedProductCardStyles } from "@waytek/Overrides/Components/PurchasedProductCard";
import { fontFamily, fontFamilyAlt, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
    globalDarkerGray: getColor("common.global.darkerGray"),
    globalWhite: getColor("common.global.white"),
    globalSecondaryGray: getColor("common.global.secondaryGray"),
    globalGuardianBlue: getColor("common.global.guardianBlue"),
};

purchasedProductCardStyles.container = {
    ...purchasedProductCardStyles.container,
    css: css`
        padding: 25px 25px 36px;
        background-color: ${localColors.globalWhite};
        border-bottom: 1px solid ${localColors.globalIndustrialTaupe};

        &:nth-child(1) {
            border-top: 12px solid ${localColors.globalIndustrialTaupe};
        }

        ${mediaQueriesBP.maxMD} {
            &&& {
                padding: 15px 10px;
            }
        }
    `,
};

purchasedProductCardStyles.leftColumnGridItem = {
    ...purchasedProductCardStyles.leftColumnGridItem,
    width: [12, 12, 2, 2, 3],
    css: css`
        margin: 0;
    `,
};

purchasedProductCardStyles.leftColumnGridContainer = {
    ...purchasedProductCardStyles.leftColumnGridContainer,
    css: css`
        &&& {
            > div {
                width: 100%;
                margin: 0;
            }
        }
    `,
};

purchasedProductCardStyles.imageGridItem = {
    ...purchasedProductCardStyles.imageGridItem,
    width: [5, 5, 12, 12, 12],
    css: css`
        &&& {
            padding: 10px;
            border: 1px solid ${localColors.globalIndustrialTaupe};
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: 280px;
            max-height: 210px;
            img {
                aspect-ratio: 4/3;
                object-fit: contain;
            }
        }
    `,
};

purchasedProductCardStyles.descriptionMobileGridItem = {
    ...purchasedProductCardStyles.descriptionMobileGridItem,
    width: [7],
    css: css`
        flex-direction: column;
        padding: 0 15px;

        ${mediaQueriesBP.minMD} {
            display: none;
        }
    `,
};

purchasedProductCardStyles.rightColumnGridItem = {
    ...purchasedProductCardStyles.rightColumnGridItem,
    width: [12, 12, 10, 10, 9],
};

purchasedProductCardStyles.rightColumnGridContainer = {
    ...purchasedProductCardStyles.rightColumnGridContainer,
    css: css`
        padding: 10px 0 0;

        ${mediaQueriesBP.minMD} {
            padding: 0 0 0 15px;
            width: 50%;
        }
    `,
};

purchasedProductCardStyles.infoGridItem = {
    ...purchasedProductCardStyles.infoGridItem,
    width: [12, 12, 4, 5, 5],
    css: css`
        padding-right: 15px;

        ${mediaQueriesBP.minMD} {
            padding-right: 5px;
        }

        ${mediaQueriesBP.minLG} {
            padding-right: 35px;
        }
    `,
};

purchasedProductCardStyles.brandGridItem = {
    ...purchasedProductCardStyles.brandGridItem,
    css: css`
        &&& {
            margin-bottom: 15px;

            ${mediaQueriesBP.maxMD} {
                display: none;
            }
        }
    `,
};

purchasedProductCardStyles.brandStylesMobile = {
    ...purchasedProductCardStyles.brandStylesMobile,
    css: css`
        &&& {
            ${mediaQueriesBP.maxMD} {
                margin-bottom: 15px;
            }
        }
    `,
};

purchasedProductCardStyles.partNumbersGridItemMobile = {
    ...purchasedProductCardStyles.partNumbersGridItemMobile,
    css: css`
        &&& {
            margin: 10px 0;
            flex-grow: 0;
            > div {
                margin: 0;
            }

            span {
                font-family: ${fontFamilyAlt};
                font-size: 14px;
                color: ${localColors.globalSecondaryGray};
                padding-left: 0;
                font-weight: normal;
            }
        }
    `,
};

purchasedProductCardStyles.descriptionGridItem = {
    ...purchasedProductCardStyles.descriptionGridItem,
    css: css`
        &&& {
            span {
                font-family: ${fontFamily};
                font-size: 16px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-decoration: none;
                border-bottom: 0;
                color: ${localColors.globalGuardianBlue};
            }
        }
    `,
};

purchasedProductCardStyles.partNumbersGridItem = {
    ...purchasedProductCardStyles.partNumbersGridItem,
    css: css`
        &&& {
            ${mediaQueriesBP.maxMD} {
                display: none;
            }
            margin: 10px 0;
            span {
                font-family: ${fontFamilyAlt};
                font-size: 14px;
                color: ${localColors.globalSecondaryGray};
                padding-left: 0;
            }
        }
    `,
};

purchasedProductCardStyles.productLabelsGridItem = {
    ...purchasedProductCardStyles.productLabelsGridItem,
    css: css`
        padding: 5px 0;
        ${mediaQueriesBP.maxMD} {
            display: none;
        }
    `,
};

purchasedProductCardStyles.productLabelsGridContainer = {
    ...purchasedProductCardStyles.productLabelsGridContainer,
    css: css`
        div {
            padding-right: 0;
        }
    `,
};

purchasedProductCardStyles.productMinQtyWrapper = {
    ...purchasedProductCardStyles.productMinQtyWrapper,

    css: css`
        margin: 10px 0 0 0;
        flex-grow: 0;

        ${mediaQueriesBP.maxMD} {
            &.desktop {
                display: none;
            }

            &.mobile {
                margin: 0 0 5px 0;
            }
        }
    `,
};

purchasedProductCardStyles.productStockWrapper = {
    ...purchasedProductCardStyles.productStockWrapper,
    css: css`
        margin-top: 5px;
        flex-grow: 0;

        ${mediaQueriesBP.minMD} {
            margin-top: 10px;

            span {
                line-height: 1;
            }
        }

        ${mediaQueriesBP.maxMD} {
            &.desktop {
                display: none;
            }
        }
    `,
};

purchasedProductCardStyles.productMinQtyStockItem = {
    ...purchasedProductCardStyles.productMinQtyStockItem,
    css: css`
        margin: 0;
    `,
};

purchasedProductCardStyles.productMinQtyStockLabel = {
    ...purchasedProductCardStyles.productMinQtyStockLabel,
    weight: 600,
    lineHeight: 1.71,
    css: css`
        flex: 0 0 auto;
        font-size: 14px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        padding-right: 0.4em;
    `,
};

purchasedProductCardStyles.productMinQtyStockValue = {
    ...purchasedProductCardStyles.productMinQtyStockValue,
    weight: "normal",
    lineHeight: 1.71,
    css: css`
        flex: 1 1 auto;
        min-width: 0;
        font-size: 14px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
    `,
};

purchasedProductCardStyles.priceBreakGridItem = {
    ...purchasedProductCardStyles.priceBreakGridItem,
    width: [12, 12, 5, 5, 5],
    css: css`
        > div {
            width: 100%;
            max-width: 231px;
        }
        padding-right: 0;

        ${mediaQueriesBP.maxMD} {
            &&& {
                margin-top: 15px;
            }
        }

        ${mediaQueriesBP.minMD} {
            padding-right: 10px;
            padding-left: 10px;
            justify-content: center;
        }

        ${mediaQueriesBP.minLG} {
            padding-right: 75px;
            padding-left: 36px;
        }
    `,
};

purchasedProductCardStyles.productMinQtyMobile = {
    ...purchasedProductCardStyles.productMinQtyMobile,
    css: css`
        &&& {
            ${mediaQueriesBP.minMD} {
                display: none;
            }
        }
    `,
};

purchasedProductCardStyles.actionsGridItem = {
    ...purchasedProductCardStyles.actionsGridItem,
    width: [12, 12, 3, 2, 2],
    css: css`
        ${mediaQueriesBP.maxMD} {
            &&& {
                margin-top: 16px;
            }
        }
    `,
};

purchasedProductCardStyles.actionsContainer = {
    ...purchasedProductCardStyles.actionsContainer,
    css: css`
        > div {
            justify-content: flex-end;

            ${mediaQueriesBP.maxMD} {
                justify-content: flex-start;
                position: relative;
                padding-bottom: 30px;
            }
        }
    `,
};

purchasedProductCardStyles.priceGridItem = {
    ...purchasedProductCardStyles.priceGridItem,
    width: 12,
    css: css`
        &&& {
            justify-content: flex-start;
            margin-bottom: 5px;
        }

        ${mediaQueriesBP.minMD} {
            &&& {
                padding: 0;
                justify-content: flex-end;
            }
        }
    `,
};

purchasedProductCardStyles.quantityGridItem = {
    ...purchasedProductCardStyles.quantityGridItem,
    width: 12,
    css: css`
        max-width: 122px;

        ${mediaQueriesBP.maxMD} {
            max-width: 100px;
        }
    `,
};

purchasedProductCardStyles.addToGridItem = {
    ...purchasedProductCardStyles.addToGridItem,
    width: 12,
    css: css`
        &&& {
            max-width: 122px;
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;

            ${mediaQueriesBP.maxMD} {
                margin: 0 0 0 10px;
                max-width: 125px;
            }
        }
    `,
};

purchasedProductCardStyles.addToCartButton = {
    ...purchasedProductCardStyles.addToCartButton,
    css: css`
        &&& {
            padding: 0 22px;
            width: 100%;
        }
    `,
};

purchasedProductCardStyles.addToListWrapper = {
    ...purchasedProductCardStyles.addToListWrapper,
    css: css`
        &&& {
            text-align: left;
            margin-top: 5px;

            ${mediaQueriesBP.maxMD} {
                position: absolute;
                left: 0;
                bottom: 0;
            }
        }
    `,
};

purchasedProductCardStyles.headingAndTextStyles = {
    ...purchasedProductCardStyles.headingAndTextStyles,
    wrapper: {
        ...purchasedProductCardStyles.headingAndTextStyles?.wrapper,
        css: css`
            ${purchasedProductCardStyles.headingAndTextStyles?.wrapper?.css}
            align-items: center;
            flex-direction: row;
            margin-bottom: 5px;
        `,
    },
    heading: {
        ...purchasedProductCardStyles.headingAndTextStyles?.heading,
        variant: "p",
        forwardAs: "span",
        weight: 600,
        lineHeight: 1.71,
        size: 14,
        css: css`
            ${purchasedProductCardStyles.headingAndTextStyles?.heading?.css}
            margin-bottom: 0;
            margin-right: 5px;
        `,
    },
    text: {
        ...purchasedProductCardStyles.headingAndTextStyles?.text,
        variant: "p",
        forwardAs: "span",
        lineHeight: 1.71,
        size: 14,
        css: css`
            ${purchasedProductCardStyles.headingAndTextStyles?.text?.css}
            width: auto;
            margin-bottom: 0;
        `,
    },
};
